<div #outerWrapper><div #viewContainer></div></div><ng-content></ng-content>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/@agm/snazzy-info-window/directives/snazzy-info-window.d.ts.AgmSnazzyInfoWindow.html